"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.offerCreator.name': 'Creador de Ofertas',
    'tools.offerCreator.description': 'Detecta y completa información de oferta/cotización de mensajes de usuario incluyendo detalles de empresa, tipos de tributación y actividades comerciales',
};
